export default async function PingLoginAuditApi() {
  try {
    const token = 'Bearer ' + localStorage.getItem('authToken');
    await fetch(`${process.env.REACT_APP_API_URL}v1/login-audit/ping`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
  } catch (_) {
    // fire-and-forget, never block the user
  }
}
